module.exports = __webpack_public_path__ + "img/qrcode.3b08c13c.jpeg";